/* eslint-disable no-console */
import { datadogRum } from '@datadog/browser-rum'

const logger = {
  error: (...args) => {
    console.error(...args)
    datadogRum.addError(...args)
  }
}

export default logger
